import { render } from "./RegRequisitions.vue?vue&type=template&id=8356b42e"
import script from "./RegRequisitions.vue?vue&type=script&lang=js"
export * from "./RegRequisitions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__